import { catchError, concatMap, map, Observable, of, take, timeout } from 'rxjs';

/** Upper bound on the best-effort FCM token removal after logout. */
export const LOGOUT_FCM_CLEANUP_TIMEOUT_MS = 5000;

/**
 * Best-effort removal of this device's FCM token on logout. Never errors and is bounded,
 * so it can run fire-and-forget: the `/login` redirect must not wait on it (a hung
 * request used to strand an already-running app after session expiry).
 */
export function logoutFcmCleanup$(
  deviceId$: Observable<string | null | undefined>,
  deleteFcmToken: (deviceId: string) => Observable<unknown>,
  timeoutMs = LOGOUT_FCM_CLEANUP_TIMEOUT_MS,
): Observable<null> {
  return deviceId$.pipe(
    take(1),
    concatMap(deviceId => (deviceId ? deleteFcmToken(deviceId) : of(null))),
    timeout({ first: timeoutMs }),
    take(1),
    map((): null => null),
    catchError((): Observable<null> => of(null)),
  );
}
